module.exports = __webpack_public_path__ + "img/908-4c4d93.png";